import Keycloak, { KeycloakServerConfig } from 'keycloak-js'

export const initKeyCloak = (config: KeycloakServerConfig): Promise<Keycloak> => {
    const { clientId, realm, url } = config
    const keyCloakAuth = new Keycloak({
        clientId: clientId,
        realm: realm,
        url: url,
    })
    return new Promise((resolve, reject) => {
        keyCloakAuth
            .init({
                onLoad: 'login-required',
                checkLoginIframe: false,
            })
            .then(() => resolve(keyCloakAuth))
            .catch(() => reject())
    })
}
